// Copyright (c) Move Closer 2022.

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function absoluteSlug (slug: string): string {
  return `/${slug.split('/').filter(p => !!p).join('/')}`
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function appendToSlug (current: string, append: string, absolute: boolean = true): string {
  const parts: string [] = current.split('/')
  parts.push(append)

  const result: string = parts.filter(p => !!p).join('/')
  return absolute ? `/${result}` : result
}
